import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SubList } from "./_forms";

export default function Contracts({ staff }) {
  const staffName = (id) => staff.find((x) => x.id === id)?.full_name || id;
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    api.get("/projects").then(({ data }) => setProjects(data || [])).catch(() => setProjects([]));
  }, []);

  const CANONICAL_DEPTS = [
    "Administration", "Engineering", "Projects", "Operations",
    "Finance", "Human Resources", "Procurement", "Compliance",
    "Survey", "Geotechnical", "Field Operations", "Corporate Services",
    "Information Technology", "Health & Safety",
  ];
  const seenDepts = new Set(CANONICAL_DEPTS);
  staff.forEach((s) => { if (s.department) seenDepts.add(s.department); });
  const deptOptions = [...seenDepts].sort().map((d) => [d, d]);

  const CANONICAL_POSITIONS = [
    "Engineer", "Senior Engineer", "Project Engineer", "Geotechnical Engineer",
    "Structural Engineer", "Field Surveyor", "Resident Engineer",
    "Project Manager", "Department Manager", "Director",
    "HR Officer", "HR Manager", "Finance Officer", "Finance Manager",
    "Admin Officer", "Procurement Officer", "Compliance Officer",
    "Asset Officer", "Storekeeper", "Driver", "Office Assistant",
    "Regulatory Specialist", "Quality Assurance Officer",
  ];
  const seenPos = new Set(CANONICAL_POSITIONS);
  staff.forEach((s) => { if (s.designation) seenPos.add(s.designation); });
  const positionOptions = [...seenPos].sort().map((p) => [p, p]);

  const SENIOR_KEYWORDS = ["manager", "director", "lead", "head", "chief", "officer in charge"];
  const reportsToOptions = staff
    .filter((s) => SENIOR_KEYWORDS.some((k) => (s.designation || "").toLowerCase().includes(k)))
    .map((s) => [s.id, `${s.full_name} — ${s.designation || ""}`]);

  return (
    <SubList
      endpoint="/hr/contracts" dataKey="items"
      lookups={{ staff_id: staffName, reports_to: staffName }}
      createPayloadDefaults={{ salary_currency: "USD", contract_type: "fixed_term", status: "active" }}
      columns={[
        ["position", "Position", true],
        ["staff_id", "Employee"],
        ["contract_type", "Type"],
        ["project_ref", "Project"],
        ["start_date", "Start", "date"],
        ["end_date", "End", "date"],
        ["status", "Status", "badge"],
      ]}
      form={[
        { k: "staff_id", label: "Employee", type: "select", options: staff.map((s) => [s.id, `${s.full_name} (${s.employee_code || "—"})`]), required: true },
        { k: "contract_type", label: "Contract Type", type: "select", required: true, options: [
          ["permanent", "Permanent"], ["fixed_term", "Fixed Term"], ["project_based", "Project-Based"],
          ["consultancy", "Consultancy"], ["probation", "Probation"],
        ]},
        { k: "position", label: "Position", type: "select", required: true, options: positionOptions },
        { k: "department", label: "Department", type: "select", options: deptOptions },
        { k: "reports_to", label: "Reports To", type: "select", options: reportsToOptions },
        { k: "project_ref", label: "Project Assignment", type: "select",
          options: projects.map((p) => [p.id, `${p.code ? p.code + " · " : ""}${p.name}`]) },
        { k: "start_date", label: "Start Date", type: "date", required: true },
        { k: "end_date", label: "End Date", type: "date" },
        { k: "probation_end", label: "Probation End", type: "date" },
        { k: "salary_amount", label: "Salary (USD)", type: "number" },
        { k: "scope_of_work", label: "Scope of Work", textarea: true },
      ]}
      testId="contract"
      emptyText="No contracts yet. Create the first contract — alerts will trigger 60 days before expiry."
    />
  );
}
